import { Link } from "react-router-dom";
import { LegalFooter, Page } from "../../components";
import { t } from "../../i18n/t";
import { LEGAL_DOCUMENTS, type LegalDocumentKey } from "../../legal/documents";
import { Markdown } from "../../legal/Markdown";

/**
 * xmg-sec-opsdocs (P1). `/privacy` and `/terms`: anonymous, outside `RequireSession`, so anyone can read them
 * before signing up. The text is `src/legal/<document>.md` (see `legal/documents.ts` for the front matter).
 */
export function LegalScreen({ document }: { document: LegalDocumentKey }): JSX.Element {
  const doc = LEGAL_DOCUMENTS[document];
  return (
    <>
      <Page
        title={doc.title}
        caption={t("legal.version", { version: doc.version })}
        breadcrumb={<Link to="/">{t("legal.back")}</Link>}
      >
        <article className="legaldoc">
          <Markdown source={doc.body} />
        </article>
      </Page>
      <LegalFooter />
    </>
  );
}
